module.exports = __webpack_public_path__ + "img/2022年高新技术企业.5a4e96c7.jpg";